import {Directive, ElementRef, HostListener, AfterViewChecked, Input} from '@angular/core';
import {EditDataService} from "../services/edit-data.service";


@Directive({
  selector: '[edit-success]',

})
 export class EditSuccessDirective {
  edit: any;
  editDescription: any;
  editTable: any;
  closeIcon: any;

  descriptionEditable: any;
  @Input('edit-success') index: number;

  constructor(private el: ElementRef, public editDataService: EditDataService) {
  }

  @HostListener('click') click() {

    if (this.edit.attributes.contentEditable.value === "true") {
      this.editTable.ownerElement.classList.toggle("edit", true);
      this.el.nativeElement.innerHTML = 'create';
      this.el.nativeElement.style.color ='#ff9039';
      this.edit.classList.toggle("border", false);
      this.editDataService.editSuccess(this.edit.innerText);
    }
    else {
      this.editTable.ownerElement.classList.toggle("edit", false);
      this.el.nativeElement.innerHTML = ' done';
      this.el.nativeElement.style.color = '#2ecd4c';
      this.edit.classList.toggle("border", true);
    }
    this.edit.attributes.contentEditable.value  = this.edit.attributes.contentEditable.value  === "false" ? "true" : "false";


  }

  ngOnInit () {
    this.closeIcon = this.el.nativeElement.parentElement.children[1];
    this.edit = this.el.nativeElement.parentElement.children[3];
    this.editTable = this.edit.attributes.contentEditable;

  }



}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/directives/success.directive.ts